import type { TFunction } from "i18next";
import moment from "moment";

import { formatDateTime } from "~/components/common/ActionLogDrawer/helpers";
import { DISPLAY_DATE_FORMAT } from "~/constants";
import { ExportConflict } from "./types";

export const formatRange = (from: string, to: string): string =>
  `${moment(from).format(DISPLAY_DATE_FORMAT)}–${moment(to).format(
    DISPLAY_DATE_FORMAT
  )}`;

/*
 * Shared between the inline preview Alert and the pre-export confirmation
 * modal (see ConflictModal), so the wording an operator sees while still
 * picking dates never drifts from the wording they see when the backend
 * actually refuses the export (kontax-backend#926). For a shared invoice
 * number this says plainly what that means downstream: the export would
 * carry the earlier run's invoice number and EasyBill would treat the two as
 * one invoice, which is the whole reason the backend blocks it.
 */
export const formatConflictMessage = (
  conflict: ExportConflict,
  t: TFunction
): string => {
  const params = {
    range: formatRange(conflict.from, conflict.to),
    exportedAt: formatDateTime(conflict.changedAt),
    exportedBy: conflict.changedBy ?? t("conflict.unknownOperator"),
  };

  return conflict.kind === "SHARED_INVOICE_NUMBER"
    ? t("conflict.sharedInvoiceNumber", params)
    : t("conflict.overlap", params);
};
